(function () {
  var accountLink = document.querySelector('.header__icons a[href="account/login"]');
  if (accountLink) {
    accountLink.setAttribute('href', '/account/login');
    if (!accountLink.getAttribute('aria-label')) accountLink.setAttribute('aria-label', 'Account');
  }
})();

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  var swatchItem = event.target.closest('.collection-color-list .color-list-inner-item');
  if (swatchItem) {
    event.preventDefault();
    var swatch = swatchItem.closest('.change_img_color');
    if (swatch) swatch.click();
    return;
  }

  if (!event.target.matches('.read-more-collection, .read-less-collection')) return;
  event.preventDefault();
  event.target.click();
});

/* Capture quick-size clicks before the legacy theme listener so sold-out variants cannot be submitted. */
document.addEventListener('click', function (event) {
  var variantOption = event.target.closest('.coll-variant-option');
  if (!variantOption) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  if (
    variantOption.classList.contains('soldout') ||
    variantOption.hasAttribute('disabled') ||
    variantOption.getAttribute('aria-disabled') === 'true'
  ) return;

  var productId = variantOption.getAttribute('data-pro-id');
  var variantId = variantOption.getAttribute('data-id');
  var card = variantOption.closest('.card-wrapper') || variantOption.closest('.card');
  var input = card ? card.querySelector('.input-' + productId) : document.querySelector('.input-' + productId);
  var button = card ? card.querySelector('.variant-have-btn-' + productId) : document.querySelector('.variant-have-btn-' + productId);

  if (input && button && variantId) {
    input.disabled = false;
    input.value = variantId;
    button.disabled = false;
    button.click();
  }
}, true);

var tfColorProductCache = {};

function tfProductJsonUrl(productUrl) {
  var cleanUrl = (productUrl || '').split('?')[0].replace(/\/+$/, '');
  return cleanUrl ? cleanUrl + '.js' : '';
}

function tfDisableCardQuickAdd(card, productId) {
  card.querySelectorAll('.coll-variant-option').forEach(function (label) {
    label.setAttribute('aria-disabled', 'true');
    label.style.opacity = '.55';
    label.style.pointerEvents = 'none';
  });

  if (!productId) return;

  var input = card.querySelector('.input-' + productId);
  var button = card.querySelector('.variant-have-btn-' + productId);
  if (input) {
    input.value = '';
    input.disabled = true;
  }
  if (button) button.disabled = true;
}

function tfUpdateCardTitlesAndLinks(card, product, targetHref) {
  card.querySelectorAll('.card__heading a').forEach(function (link) {
    if (link.getAttribute('aria-disabled') === 'true') return;
    link.setAttribute('href', targetHref);
    link.textContent = product.title;
  });

  card.querySelectorAll('.media-link, [data-product-url]').forEach(function (element) {
    if (element.matches('[data-product-url]')) {
      element.setAttribute('data-product-url', targetHref);
    } else {
      element.setAttribute('href', targetHref);
    }
  });

  var review = card.querySelector('.alireviews-review-star-rating');
  if (review) {
    review.setAttribute('product-id', product.id);
    review.setAttribute('product-handle', product.handle);
  }
}

function tfUpdateCardPrice(card, product) {
  var priceElement = card.querySelector('.card-information .price');
  if (!priceElement || !product.variants || !product.variants.length) return;

  var prices = product.variants.map(function (variant) {
    return Number(variant.price || 0);
  }).filter(function (price) {
    return Number.isFinite(price);
  });

  if (!prices.length) return;

  var minimumPrice = Math.min.apply(Math, prices);
  var maximumPrice = Math.max.apply(Math, prices);
  var displayPrice = minimumPrice === maximumPrice
    ? tfFormatAUD(minimumPrice / 100)
    : 'From ' + tfFormatAUD(minimumPrice / 100);

  var comparePrice = Number(product.compare_at_price || 0);
  var onSale = comparePrice > minimumPrice;
  var regularPrice = priceElement.querySelector('.price__regular .price-item--regular');
  var saleRegularPrice = priceElement.querySelector('.price__sale .price-item--regular');
  var salePrice = priceElement.querySelector('.price__sale .price-item--sale');

  if (regularPrice) regularPrice.textContent = displayPrice;
  if (salePrice) salePrice.textContent = displayPrice;
  if (saleRegularPrice && onSale) saleRegularPrice.textContent = tfFormatAUD(comparePrice / 100);

  priceElement.classList.toggle('price--on-sale', onSale);
  priceElement.classList.toggle('price--sold-out', !product.available);
}

function tfUpdateCardSizes(card, product, formProductId) {
  var sizeWrappers = card.querySelectorAll('.product-with-variant-block .product-form__input');
  if (!sizeWrappers.length || !product.variants || !product.variants.length || !formProductId) return false;

  sizeWrappers.forEach(function (wrapper) {
    wrapper.innerHTML = '';

    product.variants.forEach(function (variant) {
      var label = document.createElement('label');
      label.className = 'coll-variant-option' + (variant.available ? '' : ' soldout');
      label.setAttribute('data-id', variant.id);
      label.setAttribute('data-pro-id', formProductId);
      label.setAttribute('data-variant-quantity', variant.available ? '1' : '0');
      label.textContent = variant.title;

      if (!variant.available) {
        label.setAttribute('disabled', 'disabled');
        label.setAttribute('aria-disabled', 'true');
      }

      wrapper.appendChild(label);
    });
  });

  return true;
}

function tfFetchColorProduct(targetHref) {
  var jsonUrl = tfProductJsonUrl(targetHref);
  if (!jsonUrl) return Promise.reject(new Error('Missing product URL'));

  if (tfColorProductCache[jsonUrl]) {
    return Promise.resolve(tfColorProductCache[jsonUrl]);
  }

  return fetch(jsonUrl, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  }).then(function (response) {
    if (!response.ok) throw new Error('Unable to load selected colour');
    return response.json();
  }).then(function (product) {
    tfColorProductCache[jsonUrl] = product;
    return product;
  });
}

document.addEventListener('click', function (event) {
  var readMore = event.target.closest('.read-more-collection');
  var readLess = event.target.closest('.read-less-collection');
  if (readMore || readLess) {
    var description = (readMore || readLess).closest('.collection-hero__description');
    if (!description) return;

    var truncated = description.querySelector('[data-collection-description-truncated], #truncated');
    var full = description.querySelector('[data-collection-description-full], #fullDescription');
    if (!truncated || !full) return;

    if (readMore) {
      truncated.hidden = true;
      truncated.style.display = 'none';
      full.hidden = false;
      full.style.display = 'block';
    } else {
      full.hidden = true;
      full.style.display = 'none';
      truncated.hidden = false;
      truncated.style.display = 'block';
    }
    return;
  }

  var option = event.target.closest('.collection-color-list .change_img_color');
  if (!option) return;

  event.preventDefault();

  var card = option.closest('.card-wrapper') || option.closest('.card');
  if (!card) return;

  var image = card.querySelector('.card__inner .card__media img');
  var colorLink = option.querySelector('.color-list-inner-item');
  var targetHref = colorLink ? colorLink.getAttribute('data-href') : null;
  var originalSize = card.querySelector('.coll-variant-option[data-pro-id]');
  var formProductId = originalSize ? originalSize.getAttribute('data-pro-id') : null;

  if (!targetHref) return;

  if (image && option.getAttribute('data_img')) {
    image.setAttribute('srcset', option.getAttribute('data_img'));
    image.setAttribute('src', option.getAttribute('data_img'));
  }

  /* Avoid showing the previous colour on hover while the selected product data is refreshed. */
  card.querySelectorAll('.card__inner .card__media img').forEach(function (cardImage, index) {
    if (index > 0) cardImage.hidden = true;
  });

  card.querySelectorAll('.card__heading a').forEach(function (link) {
    if (link.getAttribute('aria-disabled') !== 'true') link.setAttribute('href', targetHref);
  });
  card.querySelectorAll('.media-link').forEach(function (link) {
    link.setAttribute('href', targetHref);
  });

  card.querySelectorAll('.collection-color-list .change_img_color').forEach(function (swatch) {
    var swatchLink = swatch.querySelector('.color-list-inner-item');
    swatch.classList.remove('active-color');
    swatch.style.borderColor = '';
    swatch.style.boxShadow = '';
    if (swatchLink) swatchLink.removeAttribute('aria-current');
  });

  option.classList.add('active-color');
  option.style.borderColor = '#F45A30';
  option.style.boxShadow = '0 0 0 1px #F45A30';
  if (colorLink) {
    colorLink.setAttribute('aria-current', 'true');
    colorLink.setAttribute('role', 'button');
    colorLink.setAttribute('tabindex', '0');
  }

  tfDisableCardQuickAdd(card, formProductId);

  var requestToken = String(Date.now()) + '-' + Math.random();
  card.setAttribute('data-tf-swatch-request', requestToken);
  card.setAttribute('aria-busy', 'true');

  tfFetchColorProduct(targetHref).then(function (product) {
    if (card.getAttribute('data-tf-swatch-request') !== requestToken) return;

    tfUpdateCardTitlesAndLinks(card, product, targetHref);
    tfUpdateCardPrice(card, product);

    if (!tfUpdateCardSizes(card, product, formProductId)) {
      window.location.href = targetHref;
      return;
    }

    if (colorLink) colorLink.setAttribute('aria-label', 'Selected colour: ' + product.title);
    card.removeAttribute('aria-busy');
  }).catch(function () {
    /* Safe fallback: navigate to the selected colour rather than risk adding the wrong product. */
    window.location.href = targetHref;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-color-list .color-list-inner-item').forEach(function (swatchLink) {
    swatchLink.setAttribute('role', 'button');
    swatchLink.setAttribute('tabindex', '0');
  });
});

function tfParseCartTotal(text) {
  var cleaned = (text || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');
  return parseFloat(cleaned) || 0;
}

function tfFormatAUD(value) {
  try {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(value);
  } catch (error) {
    return '$' + value.toFixed(2);
  }
}

function tfUpdateCartTrust(root) {
  if (!root) return;

  var totals = root.querySelector('.totals');
  var totalValue = root.querySelector('.totals__total-value');
  if (!totals || !totalValue) return;

  var total = tfParseCartTotal(totalValue.textContent);
  var threshold = 150;
  var wrapper = root.querySelector('.tf-cart-conversion-note');

  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'tf-cart-conversion-note';
    wrapper.setAttribute('aria-live', 'polite');
    wrapper.style.cssText = 'margin:.8rem 0 1rem;text-align:right;';
    totals.insertAdjacentElement('afterend', wrapper);
  }

  var progress = total >= threshold
    ? 'Free standard shipping unlocked.'
    : 'You\'re ' + tfFormatAUD(Math.max(0, threshold - total)) + ' away from free standard shipping.';

  var newHtml =
    '<p style="margin:0;font-weight:600;color:#3F3336;line-height:1.45;">' + progress + '</p>' +
    '<p style="margin:.2rem 0 0;font-size:1.2rem;color:#645558;line-height:1.45;">Australian dispatch · 30-day returns on full-price items</p>';

  if (wrapper.innerHTML !== newHtml) wrapper.innerHTML = newHtml;
}

function tfRefreshCartTrust() {
  tfUpdateCartTrust(document.querySelector('#CartDrawer'));
  tfUpdateCartTrust(document.querySelector('#main-cart-footer') || document.querySelector('.cart__footer'));
}

document.addEventListener('DOMContentLoaded', function () {
  tfRefreshCartTrust();

  ['#CartDrawer', '#main-cart-footer'].forEach(function (selector) {
    var root = document.querySelector(selector);
    if (!root) return;

    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        tfRefreshCartTrust();
      });
    }).observe(root, { childList: true, subtree: true, characterData: true });
  });
});

document.addEventListener('change', function (event) {
  if (!event.target.closest('cart-drawer, cart-items, #main-cart-items')) return;
  window.setTimeout(tfRefreshCartTrust, 350);
});

document.addEventListener('shopify:section:load', tfRefreshCartTrust);
